<template>
 <div>
  <div v-if="!details">
    <Tables ref="tableGridExpense"
        :columns="[
                  'Lote',
                  'Nome Usuário',
                  'Função',
                  'Data Aprovação Coordenador',
                  'Data Aprovação Tranpostes',
                  'Obra',
                  'Inicio viagem',
                  'Fim viagem',
                  'Adiantamento',
                  'Saldo',
                  'Total Gastos',
                ]"
        :showReload="false"
        v-on:Load="onLoad"
        @check="eventcheck"
        :showButtonNew="true"
        :showCheckInput="true "
        :newHeaderStatus="true"
        :showHeader="true"
        >
         <tr v-for="(data,index)  in dataexpenses" :key="index">
            <TableColumn :IsCustomButtons="true" style="font-size: 20px; vertical-align: middle;"><input  :id="data.funcionarioId"  type="checkbox" class="w-80 colunaCheckBox"></TableColumn>
            <TableColumn :IsText="true"  :status="1" :value="data.numeroLote" />
            <TableColumn :IsText="true"  :status="1" :value="data.nomeFuncionario" />
            <TableColumn :IsText="true"  :status="1" :value="data.cargos !== null || data.cargos !== undefined ? data.cargos: '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ? data.dataAtualizacaoCoordenador == null ? 'N/D' :  dateFormat(data.dataAtualizacaoCoordenador) : '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ?  data.dataAtualizacaoControladoria == null ? 'N/D' : dateFormat(data.dataAtualizacaoControladoria) : '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ? data.obra  : 'N/D'" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data !== null ? dateFormat(data.dataInicio) : '0'" />
            <TableColumn :IsText="true"   v-on:Edit="onSelect(data)" :status="1" :value="data !== null ? dateFormat(data.dataFim) : '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ? formatMoney(data.despesasViagemTotalDto.valorLimiteDespesa): '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ? formatMoney(data.despesasViagemTotalDto.saldoDisponivel) : '0'" />
            <TableColumn :IsText="true"  :status="1" :value="data !== null ? formatMoney(data.despesasViagemTotalDto.totalGasto) : '0'" />
          </tr>
        <template #ButtonsAprova>
          <div class="buttonaprova" v-if="verificardiretoria">
            <button class="btn-rep" @click="disaApprove" ><i class="fas fa-thumbs-down"></i> Reprovar</button>
            <button class="btn-appr" @click="approve"><i class="fas fa-thumbs-up"></i> Aprovar</button>
          </div>
        </template>
    </Tables>
  </div>
  <div class="col-md-12" v-if="details">
      <Details :dataExpenseDetails="dataExpenseDetails"></Details>
    </div>
 </div>
</template>

<script>
import Search from './components/search/search.vue'
import Details from './components/details/details.vue'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'BoardTrevelExpenseEmployee',
  components: {Search, Details},
  mixins: [ActionsForm],
  props: {
    dataexpensesResponse: {
      type: Object,
      default: () => { return {} }
    },
    // Chave do lote aberto na Prestacao de Contas ('sem-lote' ou o numero). Com ela, aprovar/reprovar
    // muda so as despesas DESTE lote dos funcionarios marcados (ApproveLoteBoard), nao as de outro lote.
    loteSelecionado: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      dataexpenses: [],
      details: false,
      dataFormSearch: {
        categoria: null,
        subcategoria: null,
        situacao: null
      },
      despesaviagemid: null,
      dataExpenseDetails: {},
      checkedArray: [],
      dataCoordenador: '',
      dataControladoria: ''
    }
  },
  computed: {
    verificardiretoria () {
      if (this.dataFormSearch === undefined) return true
      if (this.dataFormSearch.situacao === null || this.dataFormSearch.situacao === undefined) return true
      return parseInt(this.dataFormSearch.situacao) === 2
    }
  },
  mounted () {
    if (Object.values(this.dataexpensesResponse).length > 0) {
      this.dataexpensess = this.dataexpensesResponse.data.data
    }
  },
  watch: {
    dataexpensesResponse (newValue) {
      this.dataexpensess = newValue.data.data
      this.dataexpenses = this.dataexpensess
      this.$refs.tableGridExpense.LoadAllByData(this.dataexpensesResponse)
    }
  },
  methods: {
    returnFormatedData () {
      let data = new Date(this.dataexpenses.coordenador)
      let day = data.getDate()
      let month = data.getMonth() + 1
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }

      return `${day}/${month}/${data.getFullYear()}`
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    dateFormat (date) {
      let dateFormated = new Date(date)
      return `${dateFormated.getDate()}/${dateFormated.getMonth() + 1}/${dateFormated.getFullYear()}`
    },
    addArray (despesa) {
      despesa.forEach(d => { this.checkedArray.push(d.id) })
    },
    removeArray (despesa) {
      despesa.forEach(d => {
        this.checkedArray.forEach(id => {
          if (id === d.id) {
            this.checkedArray.splice(this.checkedArray.indexOf(id), 1)
          }
        })
      })
    },
    eventcheck (e) {
      this.checkedArray = []
      let checks = document.querySelectorAll('.colunaCheckBox')
      if (e.checked) {
        checks.forEach(x => {
          x.checked = true
        })
        this.dataexpenses[0].despesasViagens.forEach(x => {
          this.checkedArray.push(x.id)
        })
      } else {
        checks.forEach(x => { x.checked = false })
      }
    },
    onSelect (data) {
      if (data.adiantamento) return
      this.despesaviagemid = data.id
      this.GetByidDetails()
    },
    GetByidDetails () {
      loading.push()
      TravelExpenseRepository.GetByidDetails(this.despesaviagemid)
        .then((Response) => {
          loading.pop()
          this.dataExpenseDetails = Response.data
          this.details = true
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getchecked () {
      let arrayids = []
      this.checkedArray = []
      this.dataexpenses.forEach((Element) => {
        let input = document.getElementById(Element.funcionarioId)
        if (input !== null && input !== undefined) {
          if (input.checked) {
            this.checkedArray.push(Element.funcionarioId)
          }
        }
      })
      this.checkedArray.forEach((despesaId) => {
        arrayids.push(despesaId)
      })
      return arrayids
    },
    recorteDoLote (funcionarioIds) {
      const semLote = this.loteSelecionado === 'sem-lote'
      return { FuncionarioIds: funcionarioIds, Lotes: semLote ? [] : [parseInt(this.loteSelecionado, 10)], SemLote: semLote }
    },
    approve () {
      let lstdespesa = this.getchecked()
      if (lstdespesa) {
        loading.push()
        const request = this.loteSelecionado !== null
          ? TravelExpenseRepository.ApproveLoteBoard(this.recorteDoLote(lstdespesa))
          : TravelExpenseRepository.ApproveBoard(lstdespesa)
        request
          .then((Response) => {
            this.$emit('needGetDespesasViagemDiretoria')
            loading.pop()
            toast.success('Aprovações realizadas com sucesso')
          })
          .catch((Error) => {
            loading.pop()
            toast.error('Ocorreu um erro')
          })
      }
    },
    disaApprove () {
      let lstdespesa = this.getchecked()
      if (lstdespesa) {
        loading.push()
        const request = this.loteSelecionado !== null
          ? TravelExpenseRepository.DisaApproveLoteBoard(this.recorteDoLote(lstdespesa))
          : TravelExpenseRepository.DisaApproveBoard(lstdespesa)
        request
          .then((Response) => {
            this.$emit('needGetDespesasViagemDiretoria')
            loading.pop()
            toast.success('Desaprovações realizadas com sucesso')
          })
          .catch((Error) => {
            loading.pop()
            toast.error('Ocorreu um erro')
          })
      }
    }
  }

}
</script>

<style scoped>
 .buttonaprova{
    height: 2rem;
    display: flex;
    gap:10px;
  }
  .btn-rep{
    width: 10vw;
    background: red;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.btn-appr{
    width: 10vw;
    background: #008144;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
  .btn-rep:hover{
    background: rgb(179, 1, 1);

  }
.btn-appr:hover{
    background: #01532d;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/components/boardtrevelexpenseemployee/boardtrevelexpenseemployee.vue